import Style from './index.module.less'
import FootPrint from '@/assets/image/gea/foot_print_new.png'
import FootPrintActive from '@/assets/image/gea/footprint_active_new.png'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { type Block } from '@/hoxStore/interface'
import { getUniqueHeightObjects } from '@/views/Home/components/LatestBlock/utils'
import classNames from 'classnames'
import { memo, useEffect, useRef, useState } from 'react'

interface I_Block {
  block: Block
  index: number
  indexKey: string
  y: string
  isNew?: boolean
}

function generateUniqueString() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

const LatestBlockOne = ({ blocks = [] }: { blocks: Block[] }) => {
  const { curReponsive } = useGlobalStore()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const wrapRef = useRef<HTMLDivElement>(null)
  const wrapBoxRef = useRef<HTMLDivElement>(null)
  const [showFollower, setShowFollower] = useState(false)
  const [followerData, setFollowerData] = useState<Block | null>(null)
  const [testItem, setTestItem] = useState<I_Block[]>([])
  const latestBlockDataList = useRef<I_Block[]>([])
  const latestBlockDataListTwo = useRef<Block[]>([])
  const addTermsLength = useRef(0)
  const timeIdArray = useRef<NodeJS.Timeout>()
  const wrapPositionData = useRef({ left: 0, top: 0 })

  useEffect(() => {
    if (blocks?.length && latestBlockDataList.current.length === 0) {
      latestBlockDataListTwo.current = blocks
      // 初始化数据
      //添加数据的索引，数据的key
      const newBlocks = JSON.parse(JSON.stringify(blocks)).map((item: Block, index: number) => {
        return {
          block: item,
          index,
          y: index % 2 === 0 ? '-20%' : '-80%',
          indexKey: generateUniqueString(),
        }
      })
      setTestItem(newBlocks.slice(0, 9))
      latestBlockDataList.current = newBlocks.slice(0, 9)
    }
    if (
      blocks?.length &&
      latestBlockDataList.current.length &&
      blocks[0].height !== latestBlockDataListTwo.current[0].height
    ) {
      latestBlockDataListTwo.current = blocks
      // 进到这里说明数据更新了
      // 赋值已经存在的key
      // 赋值key

      const newBlocks: I_Block[] = JSON.parse(JSON.stringify(blocks)).map((item: Block) => {
        return {
          block: item,
        }
      })
      // 赋值已经存在的indexKey和key 给新数据
      const newBlocksMap = newBlocks.map((item: I_Block) => {
        const newItem = item
        const readItem = latestBlockDataList.current.find(
          (i) => i.block.height === item.block.height,
        )
        if (readItem) {
          newItem.indexKey = readItem.indexKey
          newItem.index = readItem.index
          newItem.y = readItem.y
        }
        return newItem
      })

      // 找到新增的数据
      const newBlocksItem = newBlocksMap.filter((j: I_Block) => {
        const item = latestBlockDataList.current.find((i) => i.block.height === j.block.height)
        return !item
      })
      // 新增的长度是否是偶数个
      const isOS = newBlocksItem.length % 2 == 0
      // 新增的数据添加新的index 和indexKey
      newBlocksItem.forEach((item: I_Block, index: number) => {
        item.indexKey = generateUniqueString()
        item.index = index
        item.isNew = true
        if (isOS) {
          // 新增的为偶数个，如果上一轮第一个是-20%，则新增的第一个是-80%，否则是-20%
          if (latestBlockDataList.current[0].y === '-20%') {
            item.y = index % 2 === 0 ? '-20%' : '-80%'
          } else if (latestBlockDataList.current[0].y === '-80%') {
            item.y = index % 2 === 0 ? '-80%' : '-20%'
          }
        } else {
          // 新增的为奇数个，如果上一轮第一个是-20%，则新增的第一个是-80%，否则是-20%
          if (latestBlockDataList.current[0].y === '-20%') {
            item.y = index % 2 === 0 ? '-80%' : '-20%'
          } else if (latestBlockDataList.current[0].y === '-80%') {
            item.y = index % 2 === 0 ? '-20%' : '-80%'
          }
        }
      })
      // 新增数据的长度
      addTermsLength.current = newBlocksItem.length
      // 赋值最新的数据
      const newLatestBlockDataList = JSON.parse(JSON.stringify(latestBlockDataList.current))
      newLatestBlockDataList.forEach((element: I_Block) => {
        element.index = element.index + addTermsLength.current
      })
      // 赋值最新的数据
      setTestItem(newLatestBlockDataList)
      timeIdArray.current = setTimeout(() => {
        if (curReponsive?.size === 'mobile') {
          setShowFollower(false)
        }
        const data = [...newBlocksItem, ...newLatestBlockDataList].slice(0, 10)
        setTestItem(data)
        latestBlockDataList.current = data
        clearTimeout(timeIdArray.current)
      }, 500)
    }
  }, [blocks])

  const handleMoveItem = (index: number, block: Block | null) => {
    setFollowerData(block)
  }

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (curReponsive?.size === 'mobile') {
      const { top = 0 } = wrapRef.current?.getBoundingClientRect() || {}
      if (e.clientX > 100) {
        setPosition({ x: e.clientX - 100, y: e.clientY - top })
      } else {
        setPosition({ x: e.clientX, y: e.clientY - top })
      }
      setShowFollower(true)
    } else {
      const c_top = e.clientY - wrapPositionData.current.top
      const c_left = e.clientX - wrapPositionData.current.left
      setPosition({ x: c_left, y: c_top })
    }
  }

  return (
    <>
      <div
        className={Style.wrapBox}
        onMouseMove={handleMouseMove}
        onMouseEnter={() => {
          const { top = 0, left = 0 } = wrapRef.current?.getBoundingClientRect() || {}
          wrapPositionData.current = { top, left }
          setShowFollower(true)
        }}
        onMouseLeave={() => setShowFollower(false)}
        ref={wrapRef}
      >
        {/* 鼠标移入tooltip */}
        {showFollower && followerData?.height && (
          <div
            className={Style.follower}
            style={{
              position: 'absolute',
              left: `${position.x}px`,
              top: `${position.y}px`,
              transition: 'all 0.4s',
              color: 'color: rgb(102, 102, 102)',
            }}
          >
            {/* {showItem?.height} */}
            <div className="font_14" style={{ color: 'rgb(102, 102, 102)' }}>
              #{followerData?.height}
            </div>
            <div className="font_14" style={{ color: 'rgb(102, 102, 102)' }}>
              5 s
            </div>
          </div>
        )}
        <div
          ref={wrapBoxRef}
          className={classNames({
            [Style.wrap]: true,
            footprint_img_item_wrap: true,
          })}
        >
          <div style={{ position: 'relative', height: '100%' }}>
            {testItem.map((item, index) => {
              return (
                <div
                  style={{
                    right: `${item.index * 56}px`,
                    transform: `translateY(${item.y || 0})`,
                    opacity: 1 - index * 0.1,
                  }}
                  key={item.indexKey}
                  onMouseOver={() => {
                    handleMoveItem(index, item.block)
                  }}
                  className={classNames({
                    [Style.img]: true,
                    [Style.isAddBlock]: item.isNew,
                    footprint_img_item: true,
                  })}
                  onTransitionEnd={(e) => {
                    const left = (e.target as any).getBoundingClientRect().left || 0
                    const left_two = wrapBoxRef.current?.getBoundingClientRect().left || 0
                    if (left - left_two < 0) {
                      ;(e.target as any).style.display = 'none'
                    }
                  }}
                >
                  {item.isNew ? (
                    <img
                      className={classNames({
                        [Style.isNew]: item.isNew,
                      })}
                      src={item.y === '-20%' ? FootPrint : FootPrintActive}
                      alt=""
                    />
                  ) : null}
                  <img
                    className={classNames({
                      [Style.isNew]: item.isNew,
                    })}
                    src={item.y === '-20%' ? FootPrint : FootPrintActive}
                    alt=""
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(LatestBlockOne)
